import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import History from './pages/History2';
import Home from './pages/Home';
import Home2 from './pages/Home2';
import Home3 from './pages/Home3';
import Home4 from './pages/Home4';
import Ceo from './pages/Ceo';
import Location from './pages/Location';
import Overview from './pages/Overview';
import Software from './pages/Software';
import Medicine from './pages/Medicine';
import MedicineDesc from './pages/MedicineDesc';

import Device from './pages/Device';
import DeviceDesc from './pages/DeviceDesc';

import PdfView from './pages/PdfView';

import PRcenter from './pages/PRcenter';
import PRboard from './pages/PRboard';

import Inquiry from './pages/Inquiry';
import As from './pages/As';
import Career from './pages/Career';
import Write from './pages/Write';
import Update from './pages/Update';

import View from './pages/View';

import Login from './pages/Login';

import './App.css';
const App = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home3 />} />
        <Route path="/ver2" element={<Home2 />} />
        <Route path="/ver3" element={<Home3 />} />
        <Route path="/ver4" element={<Home4 />} />
        <Route path="/ceo" exact={true} element={<Ceo />} />
        <Route path="/overview" exact={true} element={<Overview />} />

        <Route path="/history" element={<History />} />
        <Route path="/location" element={<Location />} />
        <Route path="/software" element={<Software />} />
        <Route path="/medicine" element={<Medicine />} />
        <Route path="/device" element={<Device />} />
        <Route path="/device/:id" element={<DeviceDesc />} />
        <Route path="/medicine/:id" element={<MedicineDesc />} />

        <Route path="/pdfView" element={<PdfView />} />


        <Route path="/pr" element={<PRcenter />} />
        <Route path="/news" element={<PRboard />} />
        <Route path="/:board/view/:no" element={<View />} />


        <Route path="/as" element={<As />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/career" element={<Career />} />
        <Route path="/:board/write" element={<Write />} />
        <Route path="/:board/update/:id" element={<Update />} />

        <Route path="/login" element={<Login />} />

      </Route>
     
    </Routes>
  );
};

export default App;